import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { DocumentoNegociableService } from 'app/services/documento-negociable/documento-negociable.service';
import { SafeUrlPipe } from '../../pipes/safe-url.pipe';
import { Router } from '@angular/router';
import { MessagesTitles, MessagesGeneral , MessagesStatus} from '../../models/messages';
import {HttpErrorResponse } from '@angular/common/http';
import { environment } from 'environments/environment';

declare var $: any;
@Component({
  selector: 'app-adjuntar-archivo',
  templateUrl: './adjuntar-archivo.component.html',
  styleUrls: ['./adjuntar-archivo.component.scss'],
  providers:[
    SafeUrlPipe,MessagesTitles,MessagesGeneral,MessagesStatus
  ]
})
export class AdjuntarArchivoComponent implements OnInit {

  @Output() cerrarVentanaAdjunto: EventEmitter<boolean>;
  @Output() public idComprobanteCav = new EventEmitter<any>();
  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  
  dataNegociable : any;
  dataNegociables : any;
  adquirentesArray:any = [];
  disableClose : boolean;
  filesGral :  any=[];
  saveGral :  any=[];
  loadingGral :  any=[];
  disableAdjunto :  any=[];
  idComprobante:any;
  error_upload:boolean;
  tipoAdjunto : any;
  filesB64 = new Array();
  checkboxStates = {}
  datosEnviar: any=[];
  registrado:boolean;
  formAdjunto : FormGroup;
  loading :boolean;
  save :boolean;
  link : any;
  errorArchivo : boolean;
  mensajeAdjunto : string;
  mensajeSuccess : string;
  public archivoEnBase64 : string;

  dataEnviar: any = {
    "idComprobante": "",
    "Extension" : "",
    "TipoAdjunto" : "",
    "file_content" : "",
    "Comprobante": []
  }

  constructor( private negociableService : DocumentoNegociableService , 
               private safeUrl : SafeUrlPipe , 
               private router:Router ,
               private msgStatus:MessagesStatus ) { 

    this.dataNegociable = this.negociableService.dataNegociable;         
    this.dataNegociables = this.negociableService.dataNegociables; 
    this.adquirentesArray = this.dataNegociables.filter(
      state => state.RazonSocialProveedor === this.dataNegociable.RazonSocialProveedor
    );

    if (this.dataNegociable.Estado =='Registrado' || this.dataNegociable.Estado == 'En Evaluación') {
      this.registrado= true;
    }else{
      this.registrado= false;
    }
    
    for (let clave of this.adquirentesArray){

      this.filesGral['1'+clave.idComprobante] = clave.Adjunto_PDF;
      this.saveGral['1'+clave.idComprobante] = 0;
      this.loadingGral['1'+clave.idComprobante] = 0;
      
      if (this.filesGral['1'+clave.idComprobante] ==null) {
        this.disableAdjunto['1'+clave.idComprobante] = 0;
      }else{
        this.disableAdjunto['1'+clave.idComprobante] = 1;
      }
      
      this.filesGral['3'+clave.idComprobante] = clave.Adjunto_Conformidad;
      this.saveGral['3'+clave.idComprobante] = 0;
      this.loadingGral['3'+clave.idComprobante] = 0;
    }
    this.cerrarVentanaAdjunto = new EventEmitter();

    this.adquirentesArray.forEach(item => {
      this.checkboxStates[item.idComprobante] = false
      });
  }

  ngOnInit() {
    this.errorArchivo = false;
    this.save = false;
    this.loading = false;
    this.formAdjunto = new FormGroup({
      'idComprobante' : new FormControl(''),
      'TipoAdjunto' : new FormControl(''),
      'file_content' : new FormControl('')
    })
  }

  CerrarVentana(){
    this.cerrarVentanaAdjunto.emit();
  }

  aBinario(fileList: FileList,tipo,id){
    this.errorArchivo = false;
    let file = fileList[0];
    if ( file.type != 'application/pdf'){        
      this.error_upload = true;
    this.showNotification('warning','top','right','Solo se permite tipo PDF');
      return;
    }
    this.tipoAdjunto = tipo;
    this.errorArchivo = false;
    this.saveGral[tipo+id] = 1;
    this.filesGral[tipo+id] = file.name;
    let fileReader: FileReader = new FileReader();
    var base64;
    var archivo64;
    var self = this;
    fileReader.onload =  function(fileLoadedEvent) {
              base64 = fileLoadedEvent.target['result'];
              archivo64 = base64.split(',',2);
              self.error_upload = false;
              self.save = false;
              self.filesB64[tipo+id] = archivo64[1];
           };
        fileReader.readAsDataURL(file);
  }

  onClickPdf(tipo:string,id:string){
    this.idComprobante = id;
    const fileUpload1 = document.getElementById('fileUpload1') as HTMLInputElement;
    
    fileUpload1.onchange = () => {
      this.aBinario(fileUpload1.files,tipo,id); 
    };
  fileUpload1.click();
  }

  onClickConformidad(tipo:string,id:string){
    this.idComprobante = id;
    const fileUpload2 = document.getElementById('fileUpload2') as HTMLInputElement;
    
    fileUpload2.onchange = () => {
      this.aBinario(fileUpload2.files,tipo,id);
    };
  fileUpload2.click();
   }

   GuardarPdf(){

    this.disableClose = true;
    this.loadingGral['1'+this.idComprobante] = 1 
      if(this.filesB64["1"+this.idComprobante] != null){ 
        this.formAdjunto.controls['idComprobante'].setValue(this.idComprobante);
        this.formAdjunto.controls['TipoAdjunto'].setValue(this.tipoAdjunto);
        this.formAdjunto.controls['file_content'].setValue( (this.filesB64["1"+this.idComprobante] == null ) ? '' : this.filesB64["1"+this.idComprobante]);
        this.negociableService.guardarArchivoGDrive(this.formAdjunto.getRawValue())

          .subscribe( resp => {
            this.filesGral['1'+this.idComprobante] = resp['message'];
            this.saveGral['1'+this.idComprobante] = 0;
            this.loadingGral['1'+this.idComprobante] = 0 ;
            this.disableAdjunto['1'+this.idComprobante] = 1 ;
            this.disableClose = false;
            this.save = true;
            this.showNotification('success','top','right','PDF guardado con éxito!! ');
          }, (err: HttpErrorResponse)=> {
            this.disableClose = false;
            this.loadingGral['1'+this.idComprobante] = 0 ;
            if (err.error instanceof ErrorEvent) {
              this.msgStatus.getMessage(err.status);     
          } 
          this.showNotification('danger','top','right','PDF NO GUARDADO. '+this.msgStatus.message);
          });
        }   
  }

  GuardarConformidad(){
       
    this.dataEnviar.idComprobante = this.idComprobante;
    this.dataEnviar.TipoAdjunto = this.tipoAdjunto ;
    this.dataEnviar.Extension = 'pdf';
    this.dataEnviar.file_content = this.filesB64["3"+this.idComprobante];
    this.dataEnviar.Comprobante=[]; 

    this.datosEnviar=[];
    this.adquirentesArray.forEach(item => { 
    
       this.dataEnviar.Comprobante.push({'idComprobante': item.idComprobante})   
         
      });

    for(var i=this.dataEnviar.Comprobante.length-1; i>=0;i--){
     var row = this.dataEnviar.Comprobante[i];
      if(row.idComprobante==this.idComprobante ){
        this.dataEnviar.Comprobante.splice(i,1);
      }
   }      

if (this.dataEnviar.Comprobante.length>0) {
  this.disableClose = true;
  this.loadingGral['3'+this.idComprobante] = 1 
  this.negociableService.guardarArchivoGDrive(this.dataEnviar)
      .subscribe( resp => {
          for (let num of this.dataEnviar.Comprobante){
            this.filesGral['3'+num.idComprobante] = resp['message'];
          }
            this.adquirentesArray.forEach(item => {
            this.checkboxStates[item.idComprobante] = false
            });
          this.filesGral['3'+this.idComprobante] = resp['message'];
          this.saveGral['3'+this.idComprobante] = 0;
          this.loadingGral['3'+this.idComprobante] = 0 ;
          this.disableAdjunto['3'+this.idComprobante] = 1 ;
          this.disableClose = false;
          this.save = true;
          this.showNotification('success','top','right','CONFORMIDAD guardado con éxito!! '); 
      }, (err: HttpErrorResponse)=> {
        this.disableClose = false;
        this.loadingGral['3'+this.idComprobante] = 0 ;
        this.msgStatus.getMessage(err.status);  
       
      this.showNotification('danger','top','right','CONFORMIDAD NO GUARDADO. '+this.msgStatus.message);
      });
}
else{
    this.disableClose = true;
    this.loadingGral['3'+this.idComprobante] = 1 

      if(this.filesB64["3"+this.idComprobante] != null){ 
        this.formAdjunto.controls['idComprobante'].setValue(this.idComprobante);
        this.formAdjunto.controls['TipoAdjunto'].setValue(this.tipoAdjunto);
        this.formAdjunto.controls['file_content'].setValue( (this.filesB64["3"+this.idComprobante] == null ) ? '' : this.filesB64["3"+this.idComprobante]);
        this.negociableService.guardarArchivoGDrive(this.formAdjunto.getRawValue())
          .subscribe( resp => {
              this.adquirentesArray.forEach(item => {
                this.checkboxStates[item.idComprobante] = false
                });
              this.filesGral['3'+this.idComprobante] = resp['message'];
              this.saveGral['3'+this.idComprobante] = 0;
              this.loadingGral['3'+this.idComprobante] = 0 ;
              this.disableAdjunto['3'+this.idComprobante] = 1 ;
              this.disableClose = false;
              this.save = true;
              this.showNotification('success','top','right','CONFORMIDAD guardado con éxito!! ');
          }, (err1: HttpErrorResponse)=> {
              this.disableClose = false;
              this.loadingGral['3'+this.idComprobante] = 0 ;
              this.msgStatus.getMessage(err1.status); 
          
          this.showNotification('danger','top','right','CONFORMIDAD NO GUARDADO. '+this.msgStatus.message);
          });
      } 
    }

}
  
  showNotification(type,from,align,message){
    
    //const type = ['','info','success','warning','danger']; => tipo de notificacion
    //from = [Top,bottom,etc] => orientacion vertical
    //align = center, left, right => orientacion horizontal
  
    $.notify({
        icon: "notifications",
        message: message
    },{
        type: type,
        timer: 4000,
        placement: {
            from: from,
            align: align
        },
        template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
          '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
          '<i class="material-icons" data-notify="icon">notifications</i> ' +
          '<span data-notify="title">{1}</span> ' +
          '<span data-notify="message">{2}</span>' +
          '<div class="progress" data-notify="progressbar">' +
            '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
          '</div>' +
          '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
    });
  }


}
